import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";

export default function AddCode() {
    const [codeData, setCodeData] = useState({
        costType: "M"
    });
    const { apiCall } = useApi();
    const baseName = import.meta.env.VITE_APP_BASE_URL;

    const setData = (key, value) => {
        setCodeData((prevData) => ({ ...prevData, [key]: value }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await apiCall(`costcodes-add_code`, {
                method: "POST",
                body: codeData,
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.error);
            }

            alert("Code added successfully!");
            window.location.href = window.location.origin + baseName + `cost-codes`;
        } catch (error) {
            console.error("Error adding the code:", error);
            alert(error);
        }
    }

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-10">
                <h1 className="text-2xl font-bold">Add New Code</h1>
                <Link to={`/cost-codes/`} className="btn btn-primary self-end">
                    Back
                </Link>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
                <input
                    type="text"
                    placeholder="Project#"
                    value={codeData?.projectNumber || ""}
                    onChange={(e) => setData('projectNumber', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="DBID"
                    value={codeData?.dbid || ""}
                    onChange={(e) => setData('dbid', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Code"
                    value={codeData?.code || ""}
                    onChange={(e) => setData('code', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Description"
                    value={codeData?.description || ""}
                    onChange={(e) => setData('description', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Cost Type"
                    value={codeData?.costType || "M"}
                    onChange={(e) => setData('costType', e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />
                <input
                    type="text"
                    placeholder="Phase"
                    value={codeData?.phase || ""}
                    onChange={(e) => setData('phase', e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Location"
                    value={codeData?.location || ""}
                    onChange={(e) => setData('location', e.target.value)}
                    className="border p-2 rounded w-full"
                />

                <button type="submit" className="btn btn-primary">Add Code</button>
                <Link to={`/cost-codes/`}>
                    <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                </Link>
            </form>
        </div>
    );
};